import { render, staticRenderFns } from "./SectionLayoutCardAssumption.vue?vue&type=template&id=45a01ebd&scoped=true&"
import script from "./SectionLayoutCardAssumption.vue?vue&type=script&lang=ts&"
export * from "./SectionLayoutCardAssumption.vue?vue&type=script&lang=ts&"
import style0 from "./SectionLayoutCardAssumption.vue?vue&type=style&index=0&id=45a01ebd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a01ebd",
  null
  
)

export default component.exports